import _ from 'lodash';
import { createSelector } from 'reselect';
import {
  navigationSteps,
  navigationRoutes
} from '../../../../redux/modules/navigation/navigationHelpers';

export const currentPlanState = state => state.plan;

export const packagesSelector = createSelector(
  currentPlanState,
  (plan) => _.get(plan, 'servicePackages.packages', [])
);

export const tierOfServiceSelector = createSelector(
  packagesSelector,
  (packages) => _.flatten(_.map(packages, (pack) => pack.tierOfServices))
);

export const addableSelector = createSelector(
  currentPlanState,
  (plan) => _.get(plan, 'addAdjustCapability.add', [])
);

export const lobSelector = createSelector(
  currentPlanState,
  tierOfServiceSelector,
  addableSelector,
  (plan, tiers, isAddable) => _.map(plan.lobs, (lob, lobName) => {

    const tierKey = _.findKey(tiers, ['lineOfBusiness', lobName]);
    const tier = subscribed ? tiers[tierKey] : {};
    const subscribed = tierKey > -1;
    const addable = _.includes(isAddable, lobName);

    return {
      lobName,
      subscribed,
      addable,
      ...tier,
      ...lob
    };
  })
);

export const hasVideoLob = createSelector(
  lobSelector,
  (lobs) => _.findIndex(lobs, (lob) => lob.lobName === 'TV' && lob.subscribed) > -1
);

export const enableManageChannelSelector = createSelector(
  currentPlanState,
  (plan) => {
    const enableManageChannel = _.get(plan, 'enableManageChannel');

    return enableManageChannel !== false;
  }
);

export const enableManageEquipmentSelector = createSelector(
  currentPlanState,
  (plan) => {
    const enableManageEquipment = _.get(plan, 'enableManageEquipment');

    return enableManageEquipment !== false;
  }
);

export const manageChannelLinkSelector = createSelector(
  currentPlanState,
  (plan) => _.get(plan, 'isStreamingVideoCustomer') ? navigationRoutes[navigationSteps.myPlan.ADDON_MANAGE_STREAMING_VIDEO].path : navigationRoutes[navigationSteps.myPlan.ADDON_CHANNEL].path
);



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/plan/planSelectors.js
 **/